import BottomSection from "../../components/main/bottom.section";
import CenterSection from "../../components/main/center.section";
import { MainWrap } from "../../style/main/main";
import { motion } from "framer-motion";

const slideUpVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Home = () => {
  return (
    <MainWrap>
      <div className="main-bg">
        <div className="img-box">
          <img src="../assets/main_bg1.png" alt="" />
          <div className="overlay"></div>
        </div>
        <div className="main-bg-txt">
          {[
            "기업 정보를 지켜줄 <br /> 편리하고",
            "안전한 클라우드 <br /> 백업 서비스",
          ].map((text, i) => (
            <motion.p
              key={i}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={slideUpVariant}
              className="background-text"
              dangerouslySetInnerHTML={{ __html: text }} // <br /> 태그를 처리하기 위한 방법
            />
          ))}
        </div>
      </div>

      <CenterSection />
      <BottomSection />
    </MainWrap>
  );
};

export default Home;
